import { useMutation } from '@apollo/client';
import { Form, Modal, Typography, notification } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { updateTrainingCourseMutation } from '../constants';
import EditTrainingCourseForm from './EditTrainingCourseForm';

const { Title } = Typography;

const UpdateTrainingCourseModal = ({ visible, onFinish, onCancel }) => {
  const { trainingCourse } = visible || {};
  const [saving, setSaving] = useState(false);
  const retrieveProfilePhoto = useRef();

  const [form] = Form.useForm();
  const [updateTrainingCourse] = useMutation(updateTrainingCourseMutation);

  useEffect(() => {
    if (trainingCourse) {
      form.setFieldsValue({ ...trainingCourse });
    }
  }, [trainingCourse, form]);

  const onSubmit = useCallback(
    async (_values) => {
      setSaving(true);
      try {
        const { modules, ...values } = _values;
        let _modules;
        if (modules) {
          _modules = modules.map((a) => {
            const { __typename, ...other } = a;
            return other;
          });
        }
        await updateTrainingCourse({
          variables: {
            trainingCourse: {
              _id: trainingCourse._id,
              modules: _modules,
              ...values,
            },
          },
        });
        notification.success({
          message: 'Saved',
          description: 'Training Course updated successfully',
        });
        if (onFinish) {
          onFinish();
        }
      } catch (err) {
        console.error(err);
        notification.error({
          message: 'Error',
          description: 'We apologize.  An error occurred.',
        });
      }
      setSaving(false);
    },
    [updateTrainingCourse, onFinish, trainingCourse],
  );

  return (
    <>
      <Modal
        header={null}
        open={visible}
        closable={!saving}
        destroyOnClose={true}
        maskClosable={!saving}
        onCancel={onCancel}
        footer={null}
      >
        <div style={{ paddingTop: 24, marginBottom: 24 }}>
          <Title level={2} style={{ textAlign: 'center' }}>
            Update Training Course
          </Title>
        </div>
        <div style={{ textAlign: 'left' }}>
          {visible && (
            <EditTrainingCourseForm
              onCancel={onCancel}
              saving={saving}
              setSaving={setSaving}
              form={form}
              onSubmit={onSubmit}
              trainingCourse={trainingCourse}
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default UpdateTrainingCourseModal;
